import toastr from 'toastr';

export function showError(message: string) {
  toastr.error(message, undefined, { positionClass: 'toast-top-center' })
}